import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Field } from 'redux-form';
import { propArrayShape, propBool, propStr, propValidate, } from '../../../../../helpers/custom-prop-types';
import SolutionBaseSelect from './Base/SolutionBaseSelect';
import InputTitle from './InputTitle';
const SolutionMiddleCategory = (props) => {
    const { isRequired, label, name, solutionLargeClasses, solutionMiddleClasses, validate, } = props;
    const candidateValues = useMemo(() => solutionLargeClasses.map((solutionLargeClass) => ({
        label: solutionLargeClass.name,
        options: solutionMiddleClasses
            .filter(({ solutionLargeClassId }) => solutionLargeClassId === solutionLargeClass.id)
            .map((v) => ({
            label: v.name,
            value: v.id,
        })),
    })), [solutionLargeClasses, solutionMiddleClasses]);
    return (_jsxs("div", Object.assign({ className: 'form form-solution' }, { children: [_jsx(InputTitle, { isRequired: isRequired, label: label, tip: '' }), _jsx(Field, { candidateValues: candidateValues, component: SolutionBaseSelect, isMulti: false, maximum: 0, name: name, placeholder: '最もプロジェクト事例に当てはまるカテゴリーを選択してください', validate: validate })] })));
};
SolutionMiddleCategory.propTypes = {
    isRequired: propBool(),
    label: propStr().isRequired,
    name: propStr().isRequired,
    solutionLargeClasses: propArrayShape().isRequired,
    solutionMiddleClasses: propArrayShape().isRequired,
    validate: propValidate().isRequired,
};
SolutionMiddleCategory.defaultProps = {
    isRequired: false,
};
export default SolutionMiddleCategory;
